import styles from './ListItemContent.module.scss';

import { ReactNode } from 'react';

interface Props {
  title?: string;
  description?: string;
  children?: ReactNode;
}

export function ListItemContent(props: Props) {
  return (
    <div className={styles['list-item-content']}>
      {props.title && (
        <div className={styles['list-item-title']}>{props.title}</div>
      )}
      {props.description && (
        <p className={styles['list-item-description']}>{props.description}</p>
      )}
      {props.children && <div>{props.children}</div>}
    </div>
  );
}
